// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import loadCustomQuoteIfNeeded from "@ces/App/Handlers/CustomQuoteDetails/LoadQuoteIfNeeded";
import { CustomAppState } from "@ces/App/Store/Reducers";
import { getCustomQuoteState } from "@ces/App/Store/Selectors/xQuotesSelector";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import { PageErrorWrapper } from "@insite/content-library/Components/PageErrorWrapper";
import Page from "@insite/mobius/Page";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    const { search } = getLocation(state);
    const parsedQuery = parseQueryString<{ quoteNumber?: string }>(search);
    const quoteNumber = parsedQuery.quoteNumber;
    return {
        quoteNumber,
        quoteState: getCustomQuoteState(state, quoteNumber),
    };
};

const mapDispatchToProps = {
    loadCustomQuoteIfNeeded,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RfqCustomConfirmationPage = ({ id, quoteNumber, loadCustomQuoteIfNeeded, quoteState }: Props) => {
    useEffect(() => {
        if (quoteNumber) {
            loadCustomQuoteIfNeeded({ quoteNumber } as any);
        }
    }, []);

    return (
        <Page data-test-selector="customRfqConfirmation">
            <PageErrorWrapper
                loadFailedTextTestSelector="rfqQuoteDetails_orderNotFound"
                value={quoteState}
                notFoundMessage={siteMessage("Rfq_OrderNotFound")}
            >
                <Zone contentId={id} zoneName="Content" />
            </PageErrorWrapper>
            {/* XNG-Changes: CES-625 - add to list modal fix in quote confirmation */}
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqCustomConfirmationPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RfqCustomConfirmationPage" instead of this constant.
 */
export const RfqCustomConfirmationPageContext = "RfqCustomConfirmationPage";
